import { Empty } from "antd";
import React from "react";

function CommonNodataFound({ messege }: any) {
  return (
    <div className="w-100">
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={messege ? messege : "No data"}
        style={{ margin: "0" }}
      />
    </div>
  );
}

export default CommonNodataFound;
